// Security configuration to prevent mixed content issues
// This file ensures all API calls use HTTPS

// In production, use empty base URL so requests go through Firebase Hosting
// rewrites (firebase.json: /api/** → Cloud Run cm-backend service).
// This avoids CORS issues and keeps the Cloud Run URL private.
const PRODUCTION_API_URL = '';
const DIRECT_CLOUD_RUN_URL = 'https://cm-backend-145421301936.asia-east1.run.app';
const PRODUCTION_FRONTEND_URL = 'https://cm.bitnetit.in';

// Enhanced API URL resolution with environment detection
const getApiUrl = () => {
  // Check if we're in production environment
  const isProduction = process.env.NODE_ENV === 'production' ||
                      window?.location?.hostname === 'cm.bitnetit.in' ||
                      window?.location?.hostname?.includes('firebase') ||
                      window?.location?.hostname?.includes('web.app') ||
                      window?.location?.hostname?.includes('firebaseapp.com');
  // Get API URL from environment
  let apiUrl = process.env.REACT_APP_API_URL;

  // If no API URL is set, use empty base (Firebase rewrite) in production, localhost in development
  if (!apiUrl) {
    if (isProduction) {
      return PRODUCTION_API_URL; // Empty string = same origin = Firebase Hosting rewrite
    }
    return 'http://localhost:8080';
  }

  // Force HTTPS in production environments
  if (isProduction && apiUrl.startsWith('http://')) {
    console.warn('Detected HTTP in production environment, forcing HTTPS');
    apiUrl = apiUrl.replace('http://', 'https://');
  }

  // Validate URL format (skip for empty string)
  if (apiUrl) {
    try {
      new URL(apiUrl);
    } catch (error) {
      console.error('Invalid API URL format:', apiUrl);
      console.warn('Falling back to Firebase Hosting rewrite (empty base URL)');
      return PRODUCTION_API_URL;
    }
  }

  return apiUrl;
};

// Export secure configuration
export const API_CONFIG = {
  baseURL: getApiUrl(),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: false, // Set to true if you need cookies
};

export const FRONTEND_CONFIG = {
  baseURL: PRODUCTION_FRONTEND_URL,
  isSecure: true,
  enforceHTTPS: true,
};

// Utility function to ensure HTTPS
export const ensureHTTPS = (url) => {
  if (!url) return PRODUCTION_API_URL;

  const isProduction = process.env.NODE_ENV === 'production' ||
                      window?.location?.hostname === 'cm.bitnetit.in' ||
                      window?.location?.hostname?.includes('firebase') ||
                      window?.location?.hostname?.includes('web.app');

  if (isProduction && url.startsWith('http://')) {
    return url.replace('http://', 'https://');
  }
  return url;
};

// Enhanced mixed content detection
export const checkMixedContent = () => {
  if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
    const apiUrl = getApiUrl();
    if (apiUrl.startsWith('http://')) {
      console.error('Mixed content detected! API URL is HTTP but site is HTTPS');
      console.error('API URL:', apiUrl);
      console.error('Site URL:', window.location.href);
      return false;
    }
  }
  return true;
};

// Environment detection utility
export const getEnvironment = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'cm.bitnetit.in') return 'production';
    if (hostname.includes('firebase') || hostname.includes('web.app')) return 'staging';
    if (hostname === 'localhost') return 'development';
  }
  return process.env.NODE_ENV || 'development';
};

export default {
  API_CONFIG,
  FRONTEND_CONFIG,
  getApiUrl,
  ensureHTTPS,
  checkMixedContent,
  getEnvironment,
};
